import axios from 'api';

export const getAdminRolecomponent = (params) => {
  return axios.get(`/api/features/dashboard_management/?group__name=${params}`);
};
export const getAdminMainRole = () => {
  return axios.get(`/api/core/groups/?get_all=${true}`);
};
export const saveGrid = (params) => {
  return axios.put(`api/features/dashboard_management/update-bulk/`, params);
};
